<template>
  <span class="pet-badge" :class="{ 'is-plain': !showIcon }">
    <span v-if="showIcon" class="pet-badge__icon" :class="{ 'is-large': !small }">
      <v-icon :size="iconSize">{{ petIcon }}</v-icon>
    </span>
    <span class="pet-badge__name">{{ petName }}</span>
    <span v-if="statusColor" class="pet-badge__dot" :class="`is-${statusColor}`"></span>
  </span>
</template>

<script>
export default {
  name: 'PetNameBadge',
  props: {
    petName: {
      type: String,
      required: true
    },
    species: {
      type: String,
      required: false,
      default: ''
    },
    // Opcional. Si viene, se marca con un punto de color junto al nombre; el
    // estado no tiñe el badge entero para no competir con los chips de estado
    // que ya viven en sus propias columnas.
    status: {
      type: [Number, String],
      default: null
    },
    small: {
      type: Boolean,
      default: true
    },
    showIcon: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    petIcon() {
      const species = this.species ? this.species.toLowerCase() : '';
      const isDog = species === 'perro' || species === 'dog';
      return isDog ? 'mdi-dog' : 'mdi-cat';
    },

    iconSize() {
      return this.small ? '15' : '18';
    },

    statusColor() {
      if (this.status === null || this.status === undefined) return null;
      return {
        2: 'success',
        3: 'info',
        4: 'error',
        5: 'info',
        6: 'warning'
      }[parseInt(this.status, 10)] || 'neutral';
    }
  }
};
</script>

<style scoped>
/* El icono ya dice la especie, así que el badge no la repite con color.
   Antes era un chip sólido naranja (perro) o verde (gato): color decorativo
   que competía con el verde de "Activo" y con los estados de membresía. */
.pet-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.pet-badge__icon {
  width: 24px;
  height: 24px;
  flex: none;
  display: grid;
  place-items: center;
  border-radius: 7px;
  background: var(--pw-surface-subtle);
  border: 1px solid var(--pw-border);
  color: var(--pw-text-muted);
}
.pet-badge__icon.is-large {
  width: 28px;
  height: 28px;
  border-radius: 8px;
}
.pet-badge__icon >>> .v-icon {
  color: var(--pw-text-muted);
}

.pet-badge__name {
  font-weight: 500;
  color: var(--pw-text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pet-badge__dot {
  width: 7px;
  height: 7px;
  flex: none;
  border-radius: 50%;
}
.pet-badge__dot.is-success { background: var(--pw-success); }
.pet-badge__dot.is-error   { background: var(--pw-error); }
.pet-badge__dot.is-warning { background: var(--pw-warning); }
.pet-badge__dot.is-info    { background: var(--pw-info); }
.pet-badge__dot.is-neutral { background: var(--pw-text-faint); }
</style>
